import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { SharedFormPipesModule } from '@sondermind/iris/form-helpers';

import { IrisHint } from './directives/hint';
import { IrisFormFieldComponent } from './form-field.component';
import { IsFormFieldInvalidAndTouchedPipe } from './pipes/is-form-field-invalid-and-touched.pipe';
import { IsFormFieldRequiredPipe } from './pipes/is-form-field-required.pipe';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedFormPipesModule,
    IrisHint
  ],
  declarations: [
    IrisFormFieldComponent,
    IsFormFieldRequiredPipe,
    IsFormFieldInvalidAndTouchedPipe
  ],
  exports: [
    IrisFormFieldComponent,
    IrisHint,
  ]
})

export class IrisFormFieldModule {}
